<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0"
         :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listeDevis.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listeDevis.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div
      class="column is-12 overflow-auto
      is-marginless"
      :class="[
           {'hauteur-brief-filtre': errors.length === 0},
           {'hauteur-brief-filtre-errors': errors.length > 0}
         ]">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0 mgt-10px" v-if="afficherDate">
          <input-periode
            v-model="critereRecherche.dates"
            :disabled="disabledDateFin"
            :label="$t('listeCommandeCommissions.table.filtre.date')">
          </input-periode>
        </div>
        <div v-if="!isContrat" class="column is-12 pdb-0 mgt-10px">
          <libelle-tag-input
                        :label="$t('listeCommandeCommissions.table.filtre.etat')"
                        :items="constantes.ALL_FOURNISSEUR_ETAT_COMMISSION"
                        v-model="critereRecherche.commissionEtat">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeCommandeCommissions.table.filtre.type')">
            <b-select v-model="critereRecherche.typesReferenceExterne" expanded>
              <option :value="null"></option>
              <option
                v-for="item in constantes.ALL_TYPE_REFERENCE_EXTERNE_FOURNISSEUR"
                :key="item.value"
                :value="[item.value]">
                    {{ $t(item.libelle) }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div v-if="!isContrat && modulePlanMediaActive" class="column is-12 pdb-0">
          <query-tag-input
              :label="$t('listeCommandeCommissions.table.filtre.planMedia')"
              v-model="critereRecherche.planMediaIds"
              field="code"
              :query="(search) => getAllPlanMedia({
                  query: {
                    code: search,
                    societeId: this.societeActiveId,
                  }
              })">
            <template slot-scope="props">
              {{ props.option.code }}
            </template>
          </query-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <query-tag-input
              :label="$t('listeCommandeCommissions.table.filtre.commande')"
              :disabled="isCommande"
              v-model="critereRecherche.referencesExternesCommandesIds"
              field="code"
              :query="(search) => getAllCommande({
                  query: {
                    code: search,
                    societeId: this.societeActiveId,
                    sens: constantes.SENS_VENTE,
                  },
                })">
            <template slot-scope="props">
              {{ props.option.code }}
            </template>
          </query-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <query-tag-input
              :label="$t('listeCommandeCommissions.table.filtre.facture')"
              :disabled="isFacture"
              v-model="critereRecherche.referencesExternesFacturesIds"
              field="code"
              :query="(search) => getAllFacture({
                  query:
                    {
                      code: search,
                      societeId: this.societeActiveId,
                      sens: constantes.SENS_VENTE,
                    },
                })">
            <template slot-scope="props">
              {{ props.option.code }}
            </template>
          </query-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeCommandeCommissions.table.filtre.avecAnnulations')">
            <b-select v-model="critereRecherche.avecAnnulations" expanded>
              <option :value="true"> {{ $t('general.oui') }}</option>
              <option :value="false"> {{ $t('general.non') }}</option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('listeDevis.filtre.actions.appliquer')}}</button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('listeDevis.filtre.actions.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { SENS_VENTE } from '@/configuration/devisConf';
import { ALL_TYPE_REFERENCE_EXTERNE_FOURNISSEUR, ALL_FOURNISSEUR_ETAT_COMMISSION } from '@/configuration/dcf/dcfConf';
import messageErreur from '@/services/general/messageErreur';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { SET_CRITERE_RECHERCHE } from '@/store/modules/commande-mutation-type';
import genererFacturefournisseur from '@/services/facture/factureFournisseur/genererCritereRechercheFactureFournisseur';
import { getAll as getAllPlanMedia } from '@/api/planMedia';
import { getAll as getAllCommande } from '@/api/commande';
import { getAll as getAllFacture } from '@/api/facture/index';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import inputPeriode from '@/components/general/inputPeriode';
import queryTagInput from '@/components/general/tagInput/queryTagInput';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');
const CommandeFournisseur = createNamespacedHelpers('commandeFournisseur');

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    afficherFiltreCommercial: {
      type: Boolean,
      required: true,
    },
    afficherDate: {
      type: Boolean,
      required: false,
      default: true,
    },
    isFacture: {
      type: Boolean,
      required: false,
    },
    isCommande: {
      type: Boolean,
      required: false,
    },
    disabledDateFin: {
      type: Boolean,
      required: false,
    },
    isContrat: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    libelleTagInput,
    errorMsgComponent,
    inputPeriode,
    queryTagInput,
  },
  data() {
    return {
      errors: [],
      critereRecherche: null,
      commercialSelected: [],
      constantes: {
        ALL_FOURNISSEUR_ETAT_COMMISSION,
        ALL_TYPE_REFERENCE_EXTERNE_FOURNISSEUR,
        SENS_VENTE,
      },
      getAllPlanMedia,
      getAllCommande,
      getAllFacture,
      commercialTags: null,
      listeCommercialBase: null,
      devis: [],
      facture: null,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    modulePlanMediaActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePlanMedia.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...CommandeFournisseur.mapMutations({
      setCritereRecherche: SET_CRITERE_RECHERCHE,
    }),
    deleteTiersId() {
      this.critereRecherche.tiersId = [];
      this.tiers = null;
    },
    viderCritere() {
      this.critereRecherche = cloneDeep(genererFacturefournisseur());
      this.devis = [];
      this.facture = null;
    },
    appliquerCritere() {
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },

    async initializeFiltre() {
      this.critereRecherche = cloneDeep(this.value);
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametreUtilisateur();
        await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.modulePlanMedia.key]);
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw (e);
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
